<template>
    <div class="montly-magement-report-section d-flex flex-column my-4" v-if="!!section">
        <div class="montly-magement-report-section__title">
            <app-sub-title :text="`${section.order} - ${section.name}`" />
        </div>
        <div class="montly-magement-report-section__body">
            {{ section.description }}
        </div>
        <div class="montly-magement-report-section__chart d-flex justify-content-center mt-2">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        section: {
            type: Object,
            default: null
        }
    }
}
</script>